<template>
  <div class="legendLoadingWrapper">
    <div class="legendLoadingItem">
      <q-skeleton size="15px" />
      <q-skeleton height="12px" width="100%" />
    </div>
    <div class="legendLoadingItem">
      <q-skeleton size="15px" />
      <q-skeleton height="12px" width="100%" />
    </div>
    <div class="legendLoadingItem">
      <q-skeleton size="15px" />
      <q-skeleton height="12px" width="100%" />
    </div>
  </div>
</template>

<script>

export default {
  name: "LegendLoading",
};
</script>

<style scoped lang="scss">
.legendLoadingWrapper {
  margin-bottom: 7px; display: flex; flex-direction: column; gap: 7px;
}
.legendLoadingItem {
  display: flex; align-items: center; gap: 10px; padding: 0 10px;
}
</style>
